import { type FC } from "react"

import InputField from "~/components/InputField"
import { type ExternalBuyLinkState, externalBuyLabelMaxLength } from "~/hooks/useExternalBuyLink"

type Props = { type: "course" | "video" | "downloadable" | "session" | "event"; link: ExternalBuyLinkState }

const ExternalBuyLinkFields: FC<Props> = ({ type, link }) => (
	<div className="flex flex-col gap-3">
		<InputField
			label="Buy link (optional)"
			value={link.url}
			onChange={link.setUrl}
			inputType="url"
			placeholder="https://"
		/>
		<InputField
			label="Button text (optional)"
			value={link.label}
			onChange={link.setLabel}
			placeholder="Buy"
			maxCharacters={externalBuyLabelMaxLength}
			disabled={link.url.trim().length === 0}
		/>
		{link.error !== null ? (
			<p role="alert" className="text-sm text-red-700">
				{link.error}
			</p>
		) : (
			<p className="text-light text-sm">
				If you sell this {type} on another website, visitors see a button to it instead of a notice that it
				isn't available for purchase. Give buyers access afterwards from the dashboard or through an
				integration.
			</p>
		)}
	</div>
)

export default ExternalBuyLinkFields
